import React, { useState, useEffect, useRef } from "react";
import Header from "../Components/Header";
import Sidebar from "../Components/Sidebar";
import Footer from "../Components/Footer";
import Chart from "react-apexcharts";
import RouteApi from "../Backend/Backend";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify"; // Import Toastify for notifications
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


const Account = () => {

    const { id } = useParams();

    const { fetchAllPayments, savePayType, fetchPaymentType, verifyPayment, getAiResponse } = RouteApi();

    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);

    const [chartCategories, setChartCategories] = useState([]);
    const [chartData, setChartData] = useState([]);

    const fetchAllPaymentsResult = async () => {
        try {
            const result = await fetchAllPayments();
            setPayments(result);

            const now = new Date();
            const currentMonth = now.getMonth(); // 0 = Jan
            const currentYear = now.getFullYear();

            // Filter only payments from the current month and year
            const currentMonthPayments = result.filter(p => {
                const date = new Date(p.date);
                return date.getMonth() === currentMonth && date.getFullYear() === currentYear;
            });

            // Group by day of the month
            const dayCounts = {};
            currentMonthPayments.forEach(payment => {
                const date = new Date(payment.date);
                const day = date.getDate(); // 1–31
                dayCounts[day] = (dayCounts[day] || 0) + 1;
            });

            // Build chart data arrays
            const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
            const categories = Array.from({ length: daysInMonth }, (_, i) => `${i + 1}`);
            const data = categories.map(day => dayCounts[day] || 0);

            setChartCategories(categories);
            setChartData(data);
        } catch (error) {
            console.error("Error fetching all payments:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllPaymentsResult();
    }, []);

    const chartOptions = {
        chart: {
            type: "bar",
            toolbar: { show: false },
            zoom: { enabled: false },
            foreColor: "#666",
        },
        stroke: {
            curve: "smooth",
            width: 3,
        },
        colors: ["#7D3C98"],
        grid: {
            borderColor: "#f1f1f1",
            strokeDashArray: 4,
        },
        xaxis: {
            categories: chartCategories,
            title: { text: "Days in Current Month" },
            labels: { rotate: 0 },
        },
        yaxis: {
            title: { text: "Payments Count" },
            min: 0,
            forceNiceScale: true,
        },
        tooltip: {
            theme: "light",
            y: {
                formatter: (val) => `${val} Payments`,
            },
        },
    };

    const chartSeries = [
        {
            name: "Payments",
            data: chartData,
        },
    ];

    useEffect(() => {
        // Initial load
        fetchAllPaymentsResult();
      
        // ✅ Whenever any API call completes anywhere in the app
        const handleGlobalRefresh = () => {
          console.log("🔄 Global API change detected → refreshing payments...");
          fetchAllPaymentsResult();
        };
      
        window.addEventListener("api:refresh", handleGlobalRefresh);
      
        // Cleanup
        return () => {
          window.removeEventListener("api:refresh", handleGlobalRefresh);
        };
    }, []);

    const refreshIntervalRef = useRef(null);

    const handleAutoRefresh = () => {
    // Prevent multiple intervals running
    if (refreshIntervalRef.current) return;

    toast.info("Auto-refreshing payment list every 5 seconds...");

    refreshIntervalRef.current = setInterval(() => {
        console.log("🔁 Auto refreshing payment list...");
        fetchAllPaymentsResult();
    }, 5000);
    };

    // Optional cleanup when component unmounts
    useEffect(() => {
    return () => {
        if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
        refreshIntervalRef.current = null;
        }
    };
    }, []);
    
    const classList = [
    "JSS1", "JSS2", "JSS3",
    "SSS1", "SSS2", "SSS3",
    "Grade 1", "Grade 2", "Grade 3", "Grade 4", "Grade 5", "Grade 6",
    "KG 1", "KG 2", "NUR 1", "NUR 2", "Playgroup"
    ];

  const [paymentType, setPaymentType] = useState("");
  const [amount, setAmount] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!paymentType || !amount || !selectedClass) {
      toast.warning("⚠️ Please fill all fields before saving");
      return;
    }
  
    const data = {
      paymentType,
      amount,
      class: selectedClass,
    };
  
    try {
      setIsLoading(true);
      console.log("✅ Payment Type Data:", data);
  
      const result = await savePayType(data);
  
      if (result?.status === "success") {
        toast.success(result.message || "✅ Payment Type Added Successfully!");
        setPaymentType("");
        setAmount("");
        setSelectedClass("");

        fetchAllPaymentTypes();

        fetchAllPaymentsResult();
  
        // Close offcanvas
        const offcanvasEl = document.getElementById("payment_offcanvas");
        const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
        bsOffcanvas.hide();
      } else {
        toast.error(result?.message || "❌ Failed to add payment type");
      }
    } catch (error) {
      console.error("❌ Error saving payment type:", error);
      toast.error("Failed to add payment type");
    } finally {
      setIsLoading(false);
    }
  };


    const [paymentTypes, setPaymentTypes] = useState([]);

    const fetchAllPaymentTypes = async () => {
        try {
            const result = await fetchPaymentType();
            setPaymentTypes(result);
            console.log("✅ All Payment Types:", result);
        } catch (error) {
            console.error("Error fetching payment types:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllPaymentTypes();
    }, []);

    const schoolname = localStorage.getItem("schoolname");
    
    const generateInvoicePDF = (payment) => {
        const doc = new jsPDF({
            orientation: "portrait",
            unit: "pt",
            format: "A4",
        });

        // 💠 Header
        doc.setFillColor('#14213D');
        doc.rect(0, 0, 595.28, 80, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(20);
        doc.text(schoolname+" School", 40, 50);

        // 💠 Title
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(18);
        doc.text("STUDENT PAYMENT INVOICE", 40, 120);

        // 💠 Table
        const details = [
            ["Student Name", payment.stud_name || "-"],
            ["Email", payment.email || "-"],
            ["Class", payment.stud_class || "-"],
            ["Payment Type", payment.payment_type || "-"],
            ["Reference", payment.reference || "-"],
            ["Amount (₦)", `${Number(payment.amount).toLocaleString()}`],
            ["Payment Status", payment.status?.toUpperCase() || "-"],
            ["Date", new Date(payment.created_at).toLocaleString()],
        ];

        autoTable(doc, {
            startY: 140,
            head: [["Field", "Details"]],
            body: details,
            styles: {
                fontSize: 11,
                cellPadding: 8,
            },
            headStyles: {
                fillColor: ['#14213D'],
                textColor: 255,
                fontStyle: "bold",
            },
            bodyStyles: {
                textColor: [40, 40, 40],
            },
            theme: "grid",
        });

        // 💠 Footer
        const pageHeight = doc.internal.pageSize.getHeight();
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text(
            "Thank you for your payment! Please keep this invoice for your records.",
            40,
            pageHeight - 40
        );
        doc.text("Generated by Smart AI - Smart Edu Inc © 2025", 40, pageHeight - 25);

        // 💾 Save PDF
        doc.save(`Invoice_${payment.reference}.pdf`);
    };
  
    return (
        <div className="bg-back">
            <Header />
            <Sidebar />

            <div className="docs-wrapper bg-back">
                <div className="container-fluid pt-lg-10 pt-2 pb-10 pb-lg-10">
                    <div className="px-2 px-lg-4">
                        <div className="row gx-6 gy-6">
                            <div className="col-12">
                                <div className="d-lg-flex align-items-center">
                                <div className="col fs-t text-q2 fw-medium mb-lg-0 mb-4">
                                    <i className="bi bi-stars text-warning"></i>
                                    <span className="ms-2">Access All Account Logs.</span>
                                </div>

                                <div className="col-auto">
                                    <button className="btn btn-purple4 text-white"
                                     data-bs-toggle="offcanvas"
                                     data-bs-target="#payment_offcanvas"
                                     aria-controls="payment_offcanvas"
                                    style={{ borderRadius: '20px' }}>
                                        <i className="bi bi-plus-lg"></i> Add Payment Type
                                    </button>
                                </div>

                                </div>
                            </div>

                            <div className="col-lg-7">
                                <div
                                    className="card shadow-none border border-0 bg-white"
                                    style={{
                                        backgroundImage: "url('../../assets/images/background/10.svg')",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "cover",
                                        backgroundPosition: "100% 100%",
                                        borderRadius: "30px",
                                    }}
                                >
                                    <div className="py-6 px-lg-8 px-4">
                                        <div className="">
                                            <div className="fs-3 text-purple3 fw-medium mb-lg-2 mb-4">
                                                Experience the Future of School Finance — Powered by Smart AI 💡
                                            </div>
                                            <div className="fs-4 text-dark mb-lg-4 mb-4">
                                                Our intelligent Account Management System lets you do more with less effort.
                                                Simply ask AI to <span className="fw-medium">create student invoices</span>,
                                                <span className="fw-medium">generate payment links</span>,
                                                <span className="fw-medium">email invoices to parents</span>, or even
                                                <span className="fw-medium">bill an entire class in seconds</span> — all seamlessly automated.
                                            </div>

                                            <div className="">
                                                <button className="btn btn-purple4 btn-sm text-white"
                                                    data-bs-toggle="offcanvas"
                                                    data-bs-target="#smart-ai"
                                                    aria-controls="smart-ai"
                                                    style={{ borderRadius: "20px" }}>
                                                    <span className="bi bi-stars text-warning fs-3"></span>{" "}
                                                    Ask Now
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-5">
                                <div
                                    className="card bg-white shadow-none"
                                    style={{ borderRadius: "20px" }}
                                >
                                    <div className="py-3 py-lg-2 px-lg-4 px-3">
                                        <h5 className="text-purple3 fw-semibold mb-3 mt-3">
                                            AI Invoice Activity
                                        </h5>
                                        <Chart
                                            options={chartOptions}
                                            series={chartSeries}
                                            type="bar" // can change to "line" or "area" too
                                            height={280}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6 order-2 order-lg-1">

                            </div>

                            <div className="col-lg-6 order-3 order-lg-2">

                            </div>

                            <div className="col-lg-12 order-1 order-lg-3"
                            onMouseEnter={() => handleAutoRefresh()}
                            onTouchStart={() => handleAutoRefresh()}>
                                <div className="card shadow-none bg-white px-lg-4 py-lg-6 px-4 py-4"
                                style={{ borderRadius: "20px" }}>
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <div className="fs-3 fw-semibold text-purple3">Student Payment Records</div>
                                        <span className="fs-4 badge bg-light text-purple2">
                                            Total: {payments.length}
                                        </span>
                                    </div>

                                    {loading ? (
                                        <div className="text-center">
                                        <div className="lds-facebook">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                      </div>
                                      </div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-striped align-middle text-dark">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>No.</th>
                                                        <th>Student</th>
                                                        <th>Class</th>
                                                        <th>Type</th>
                                                        <th>Amount (₦)</th>
                                                        <th>Status</th>
                                                        <th>Link</th>
                                                        <th>Reference</th>
                                                        <th>Invoice</th>
                                                        <th>Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-dark">
                                                    {payments.map((p, index) => (
                                                        <tr key={p.id} className="text-dark">
                                                            <td className="text-dark">{index + 1}</td>
                                                            <td>
                                                                <div className="fw-medium fs-4 text-purple3">{p.stud_name}</div>
                                                                <div className="small text-dark">{p.email}</div>
                                                            </td>
                                                            <td className="text-dark">{p.stud_class}</td>
                                                            <td className="text-dark">{p.payment_type}</td>
                                                            <td className="text-dark">₦{p.amount}</td>
                                                            <td className="text-dark">
                                                                <span
                                                                    className={`badge ${p.status === "verified"
                                                                            ? "bg-success"
                                                                            : p.status === "pending"
                                                                                ? "bg-warning text-dark"
                                                                                : "bg-danger"
                                                                        }`}
                                                                >
                                                                    {p.status}
                                                                </span>
                                                            </td>
                                                            
                                                            <td className="text-center">
                                                            <i
                                                                className="bi bi-link-45deg"
                                                                style={{ cursor: "pointer", fontSize: "1.6rem" }}
                                                                title="Copy payment link"
                                                                onClick={() => {
                                                                navigator.clipboard.writeText(p.description);
                                                                toast.success("Payment link copied to clipboard!");
                                                                }}
                                                            ></i>
                                                            </td>

                                                            <td className="small text-dark">{p.reference}</td>
                                                            <td className="small text-dark">
                                                                <button
                                                                    className="btn btn-dark btn-icon rounded-circle"
                                                                    onClick={() => generateInvoicePDF(p)}
                                                                    title="Download Invoice PDF"
                                                                >
                                                                    <span className="bi bi-download"></span>
                                                                </button>
                                                            </td>
                                                            <td className="text-dark">{new Date(p.created_at).toLocaleDateString()}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


      {/* 🟣 Offcanvas Panel */}
      <div
        className="offcanvas offcanvas-end bg-white"
        tabIndex="-1"
        id="payment_offcanvas"
        aria-labelledby="offcanvasPaymentLabel"
        style={{ width: "600px" }}
      >
        <div className="offcanvas-header align-items-center py-3 px-4 border-0">
          <div className="text-purple3 m-0 fs-3 fw-medium" id="offcanvasPaymentLabel">
            <i className="bi bi-wallet2 text-purple2"></i> Add Payment Type
          </div>
          <button
            type="button"
            className="btn btn-purple4 btn-icon rounded-br-lg2 rounded-bl-sm2 rounded-t-lg2"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="bi bi-x-lg text-white fw-bold fs-5"></i>
          </button>
        </div>

        <div className="offcanvas-body">
          <div className="px-lg-5 px-3 py-lg-4 py-8">
            <form onSubmit={handleSubmit}>
              {/* Payment Type Input */}
              <div className="mb-4">
                <label className="form-label fw-medium text-purple2 fs-4">
                  Payment Type
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg bg-back text-dark"
                  placeholder="e.g. School Fees, Books, Uniform"
                  value={paymentType}
                  required
                  onChange={(e) => setPaymentType(e.target.value)}
                  style={{ borderRadius: "15px" }}
                />
              </div>

              {/* Amount Input */}
              <div className="mb-4">
                <label className="form-label fw-medium text-purple2 fs-4">
                  Amount (₦)
                </label>
                <input
                  type="number"
                  className="form-control form-control-lg bg-back text-dark"
                  placeholder="Enter amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  style={{ borderRadius: "20px" }}
                  required
                />
              </div>

              {/* Class Dropdown */}
              <div className="mb-6">
              <label className="form-label fw-medium text-purple2 fs-4">
                  Select Class
                </label>
                <select
                  className="form-select form-select-lg bg-back text-dark"
                  value={selectedClass}
                  onChange={(e) => setSelectedClass(e.target.value)}
                  style={{ borderRadius: "20px" }}
                  required
                >
                  <option value="">-- Select Class --</option>
                  {classList.map((cls, i) => (
                    <option key={i} value={cls}>
                      {cls}
                    </option>
                  ))}
                </select>
              </div>

              {/* Submit Button */}
              <div className="d-grid">
                <button
                  type="submit"
                  className="btn btn-purple text-white btn-lg d-flex align-items-center justify-content-center gap-2"
                  style={{ borderRadius: "20px", height: "55px" }}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <div className="lds-facebook">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  ) : (
                    <>
                      <i className="bi bi-save"></i> Save Payment Type
                    </>
                  )}
                </button>
              </div>
            </form>

            <div className="d-flex justify-content-between align-items-center mb-4 mt-lg-6 mt-6">
                <div className="fs-3 fw-semibold text-purple3">Payment Type Records</div>
            </div>

            {loading ? (
                <div className="lds-facebook">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            ) : (
                <div className="table-responsive">
                <table className="table table-striped align-middle text-dark">
                    <thead className="table-white">
                    <tr>
                        <th>No.</th>
                        <th>Class</th>
                        <th>Payment Type</th>
                        <th>Amount (₦)</th>
                        <th>Date Added</th>
                    </tr>
                    </thead>
                    <tbody>
                    {paymentTypes.map((t, index) => (
                        <tr key={t.id}>
                        <td className="text-dark">{index + 1}</td>
                        <td className="text-dark">{t.class}</td>
                        <td className="text-dark">{t.payment_type}</td>
                        <td className="text-dark">₦{t.amount}</td>
                        <td className="text-dark">{new Date(t.created_at).toLocaleDateString()}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            )}
            </div>

        </div>
      </div>

            <Footer />
        </div>
    );


};

export default Account;
